import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  title = 'Maintain Lookup Tables';

  constructor(private titleService: Title) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    sessionStorage.setItem('currentSubMenuOption', '');
    sessionStorage.setItem('currentmenuOption', 'admin');
  }

}
